<template>
<div style="display:flex;">
    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab" style="flex:1;width: calc(100% - 160px);margin-right: 10px;">
        <el-tab-pane
            :key="item.path"
            v-for="(item) in stateTabsList"
            :label="item.title"
            :name="item.path"
        >
        </el-tab-pane>
    </el-tabs>
    <el-dropdown style="line-height: 40px;width:150px;text-align: right;" @command="handleCommand">
        <span class="el-dropdown-link" style="margin-right: 10px;">
            <i class="el-icon-user"></i>
            {{nickName}}
            <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>退出</el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { MessageBox} from 'element-ui'
export default {
    props: {
        nickName: {
            type: String,
            required: true
        }
    },
    watch:{
        stateCurTabName(val){
            //直接赋值给本地data中的属性，就不会报错啦
            this.editableTabsValue = val
        }
    },
    computed: {
        ...mapState({ 
            stateTabsList: state => state.app.stateTabsList,
            stateCurTabName: state => state.app.stateCurTabName 
        })
    },
    data(){
        return{
            editableTabsValue: '/homeboard'
        }
    },
    methods: {
        // 关闭页签
        removeTab(targetName) {
            if(this.stateTabsList.length<=1){
                this.$message('至少保留一个页签打开');
                return;
            }
            let tabs = this.stateTabsList;
            let activeName = this.editableTabsValue;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.path === targetName) {
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.path;
                            if(this.editableTabsValue == targetName){
                                this.editableTabsValue = activeName;
                                this.$router.push(activeName);
                                this.$store.commit('app/setCurTabName', activeName)
                            }
                        }
                    }
                });
            }
            
            this.editableTabs = tabs.filter(tab => tab.path !== targetName);
            this.$store.commit('app/mutationCloseTab', targetName); // 删除标签和缓存
        },
        async clickTab(tab) {
            let tabName = tab.name;
            if(tab.name.indexOf("/")<0){
                tabName = "/"+tabName;
            }
            if (tabName == this.$route.path) {
                return;
            }
            if(this.$route.path.split("/")[1] == tab.name.split("/")[0]){
                this.$router.push(tabName.split("/")[2]);
            }
            else{
                this.$router.push(tabName);
            }
        },
        handleCommand(command) {
            this.logout();// 退出
        },
        // 退出登录
        async logout(){
            MessageBox.confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("login/logout");
                document.location.href = '/#/login';
            }).catch(()=>{
                
            });
        }
    },  
    created() {
        let path = this.$route.path;
        if(path!=""){
            let value = {
                path,
                icon:this.$route.meta.icon,
                title:this.$route.meta.title,
                name:this.$route.name
            }
            this.$store.commit('app/mutationSelectTabs', value);
            this.editableTabsValue = path;
            this.$store.commit('app/setCurTabName', this.editableTabsValue);
        }
    }
}
</script>

<style lang="scss" scope>
    .el-tabs--card>.el-tabs__header .el-tabs__nav {
        border: 0;
    }
    .el-tabs--card>.el-tabs__header {
        border-bottom: 0;
    }
    .el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover {
        background: #E6EFF9;
        // height: 35px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        // margin-top: 5px;
    }
</style>